const convertDateToString = (date: Date) => {
  return date.toISOString().split("T")[0];
};

export default convertDateToString;
